import { css } from "lit";

const notion = css`
/**
 * Cre8 Theme: Notion
 * Generated by Cre8 Brand Themer
 * 
 * Usage: Include this CSS file after the Cre8 component styles.
 * All Cre8 components will automatically pick up these overrides.
 */

:root {
  /* ──────────── Brand Colors ──────────── */
  --cre8-color-bg-brand-subtle:    #f5f5f5;
  --cre8-color-bg-brand-strong:    #000000;
  --cre8-color-bg-brand-xstrong:   #37352f;
  --cre8-color-content-brand:      #000000;
  --cre8-color-border-brand:       #000000;

  /* ──────────── Backgrounds ──────────── */
  --cre8-color-bg-default:         #ffffff;
  --cre8-color-bg-subtle:          #fafafa;
  --cre8-color-bg-muted:           #f2f2f2;
  --cre8-color-bg-inverse:         #37352f;

  /* ──────────── Content / Text ──────────── */
  --cre8-color-content-default:    #292823;
  --cre8-color-content-subtle:     #7c776a;
  --cre8-color-content-muted:      #ada99f;
  --cre8-color-content-inverse:    #ffffff;

  /* ──────────── Borders ──────────── */
  --cre8-color-border-default:     #e8e7e4;
  --cre8-color-border-subtle:      #ffffff;
  --cre8-color-border-strong:      #c5c2bb;
  --cre8-color-border-inverse:     #605d52;

  /* ──────────── Buttons ──────────── */
  --cre8-color-button-primary-background:       #000000;
  --cre8-color-button-primary-background-hover: #000000;
  --cre8-color-button-primary-border:           #000000;
  --cre8-color-button-primary-content:          #ffffff;
  --cre8-color-button-secondary-background:     transparent;
  --cre8-color-button-secondary-border:         #000000;
  --cre8-color-button-tertiary-background:      transparent;

  /* ──────────── Links ──────────── */
  --cre8-color-link-default:       #000000;
  --cre8-color-link-hover:         #000000;
  --cre8-color-link-visited:       #000000;
  --cre8-color-link-inverse:       #2eaadc;

  /* ──────────── Header ──────────── */
  --cre8-header-background:                #37352f;
  --cre8-header-top-background:            #292823;
  --cre8-header-bottom-background:         #45423b;
  --cre8-header-middle-border-bottom-color:#525047;
  --cre8-color-header-bg-default:          #37352f;

  /* ──────────── Status Colors ──────────── */
  --cre8-color-bg-error:           #fef2f2;
  --cre8-color-border-error:       #ef4444;
  --cre8-color-content-error:      #dc2626;
  --cre8-color-bg-warning:         #fffbeb;
  --cre8-color-border-warning:     #f59e0b;
  --cre8-color-content-warning:    #d97706;
  --cre8-color-bg-success:         #f0fdf4;
  --cre8-color-border-success:     #22c55e;
  --cre8-color-content-success:    #16a34a;
  --cre8-color-bg-info:            #f5f5f5;
  --cre8-color-border-info:        #000000;
  --cre8-color-content-info:       #000000;

  /* ──────────── Border Radius ──────────── */
  --cre8-border-radius-default:    6px;
  --cre8-border-radius-lg:         9px;
  --cre8-border-radius-button:     6px;
  --cre8-border-radius-card:       9px;
  --cre8-border-radius-input:      6px;

  /* ──────────── Shadows ──────────── */
  --cre8-shadow-default:           0 1px 3px rgba(0,0,0,0.08);
  --cre8-shadow-elevated:          0 4px 12px rgba(0,0,0,0.12);
  --cre8-shadow-card:              0 2px 8px rgba(0,0,0,0.06);

  /* ──────────── Typography ──────────── */
  --cre8-font-family-default:      'Assisstant', system-ui, sans-serif;

}
`;

export default notion;